// extracted by mini-css-extract-plugin
export default {"root":"Xa3MT__root","whiteBackground":"tYtpQ__whiteBackground","customSpinnerStyles":"qov7q__customSpinnerStyles"};